/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandNationalGeographic = createReactComponent(
  "brand-national-geographic",
  "IconBrandNationalGeographic",
  [["path", { d: "M7 3h10v18h-10z", key: "svg-0" }]]
);

export { IconBrandNationalGeographic as default };
//# sourceMappingURL=IconBrandNationalGeographic.js.map
